import React, { useCallback, useContext } from "react";
import { useTranslation } from "react-i18next";
import { RaisedButton, Switch } from "@evergis/ui";
import { useDispatch } from "react-redux";
import { useProjectUpdate } from "ducks/project/hooks";
import { clearDateFilterConditions } from "ducks/dateFilter/dateFilter";
import { DateFilterContext } from "../context";
import { ActionLayerKind, Layer } from "../reducers";
import { ModalBottom, Buttons, CancelButton } from "../styled";

const simplifyLayers = (layers: Layer[]) => {
  return layers.map(layer => ({
    ...layer,
    text: layer.text && layer.text.toString(),
    aggregationColor: layer.aggregationColor.toString(),
  }));
};

export default () => {
  const updateProject = useProjectUpdate();
  const { t } = useTranslation("common");
  const dispatch = useDispatch();
  const { t: dateFilerT } = useTranslation("dateFilter");
  const {
    saveOnClose,
    changeSaveOnClose,
    setSettingVisibility,
    layerDispatcher,
    formLayers,
    formLayerDispatcher,
    layers,
    formRangeDate,
    setFormRangeDate,
    rangeDate,
    setRangeDate,
    formDurationInterval,
    setDurationInterval,
  } = useContext(DateFilterContext);

  const saveLayersData = useCallback(() => {
    updateProject({
      content: {
        clientData: {
          dateFilter: {
            layers: simplifyLayers(formLayers),
            rangeDate: formRangeDate,
            durationInterval: formDurationInterval,
            isVisible: true,
          },
        },
      },
    });
  }, [formDurationInterval, formLayers, formRangeDate, updateProject]);

  return (
    <ModalBottom>
      <Switch
        label={dateFilerT("saveOnClose")}
        checked={saveOnClose}
        onChange={() => changeSaveOnClose(state => !state)}
      />
      <Buttons>
        <CancelButton
          onClick={() => {
            setSettingVisibility(false);
            setFormRangeDate(rangeDate);
            formLayerDispatcher({ type: ActionLayerKind.AddLayers, payload: layers });
          }}
        >
          {t("actions.cancel")}
        </CancelButton>
        <RaisedButton
          primary
          onClick={() => {
            dispatch(clearDateFilterConditions());
            layerDispatcher({ type: ActionLayerKind.AddLayers, payload: formLayers });
            setRangeDate(formRangeDate);
            setSettingVisibility(false);
            setDurationInterval(formDurationInterval);
            saveOnClose && saveLayersData();
          }}
        >
          {t("actions.apply")}{" "}
        </RaisedButton>
      </Buttons>
    </ModalBottom>
  );
};
